const ci = [
  ['Миллиметр', 'мм'],
  ['Сантиметр', 'см'],
  ['Дециметр', 'дм'],
  ['Метр', 'м'],
  ['Километр; тысяча метров', 'км; 10^3 м'],
  ['Мегаметр; миллион метров', 'Мм; 10^6 м'],
  ['Дюйм (25,4 мм)', 'дюйм'],
  ['Фут (0,3048 м)', 'фут'],
  ['Ярд (0,9144 м)', 'ярд'],
  ['Морская миля (1852 м)', 'миля'],
  ['Квадратный миллиметр', 'мм^2'],
  ['Квадратный сантиметр', 'см^2'],
  ['Квадратный дециметр', 'дм^2'],
  ['Квадратный метр', 'м2'],
  ['Тысяча квадратных метров', '10^3 м^2'],
  ['Гектар', 'га'],
  ['Квадратный километр', 'км^2'],
  ['Квадратный дюйм (645,16 мм^2)', 'дюйм^2'],
  ['Квадратный фут (0,092903 м^2)', 'фут^2'],
  ['Квадратный ярд (0,8361274 м^2)', 'ярд^2'],
  ['Ар (100 м^2)', 'а'],
  ['Кубический миллиметр', 'мм^3'],
  ['Кубический сантиметр; миллилитр', 'см^3; мл'],
  ['Литр; кубический дециметр', 'л; дм^3'],
  ['Кубический метр', 'м3'],
  ['Децилитр', 'дл'],
  ['Гектолитр', 'гл'],
  ['Мегалитр', 'Мл'],
  ['Кубический дюйм (16387,1 мм^3)', 'дюйм^3'],
  ['Кубический фут (0,02831685 м^3)', 'фут^3'],
  ['Кубический ярд (0,764555 м^3)', 'ярд^3'],
  ['Миллион кубических метров', '10^6 м^3'],
  ['Гектограмм', 'гг'],
  ['Миллиграмм', 'мг'],
  ['Метрический карат', 'кар'],
  ['Грамм', 'г'],
  ['Килограмм', 'кг'],
  ['Тонна; метрическая тонна (1000 кг)', 'т'],
  ['Килотонна', '10^3 т'],
  ['Сантиграмм', 'сг'],
  ['Брутто-регистровая тонна (2,8316 м^3)', 'БРТ'],
  ['Грузоподъемность в метрических тоннах', 'т грп'],
  ['Центнер (метрический) (100 кг); гектокилограмм; квинтал (метрический); децитонна', 'ц'],
  ['Ватт', 'Вт'],
  ['Киловатт', 'кВт'],
  ['Мегаватт; тысяча киловатт', 'МВт; 10^3 кВт'],
  ['Вольт', 'В'],
  ['Киловольт', 'кВ'],
  ['Киловольт-ампер', 'кВ.А'],
  ['Мегавольт-ампер (тысяча киловольт-ампер)', 'МВ.А'],
  ['Киловар', 'квар'],
  ['Ватт-час', 'Вт.ч'],
  ['Киловатт-час', 'кВт.ч'],
  ['Мегаватт-час; 1000 киловатт-часов', 'МВт.ч; 10^3 кВт.ч'],
  ['Гигаватт-час (миллион киловатт-часов)', 'ГВт.ч'],
  ['Ампер', 'А'],
  ['Ампер-час (3,6 кКл)', 'А.ч'],
  ['Тысяча ампер-часов', '10^3 А.ч'],
  ['Кулон', 'Кл'],
  ['Джоуль', 'Дж'],
  ['Килоджоуль', 'кДж'],
  ['Ом', 'Ом'],
  ['Градус Цельсия', '°C'],
  ['Градус Фаренгейта', '°F'],
  ['Кандела', 'кд'],
  ['Люкс', 'лк'],
  ['Люмен', 'лм'],
  ['Кельвин', 'K'],
  ['Ньютон', 'Н'],
  ['Герц', 'Гц'],
  ['Килогерц', 'кГц'],
  ['Мегагерц', 'МГц'],
  ['Паскаль', 'Па'],
  ['Сименс', 'См'],
  ['Килопаскаль', 'кПа'],
  ['Мегапаскаль', 'МПа'],
  ['Физическая атмосфера (101325 Па)', 'атм'],
  ['Техническая атмосфера (98066,5 Па)', 'ат'],
  ['Гигабеккерель', 'ГБк'],
  ['Милликюри', 'мКи'],
  ['Кюри', 'Ки'],
  ['Грамм делящихся изотопов', 'г Д/И'],
  ['Миллибар', 'мб'],
  ['Бар', 'бар'],
  ['Гектобар', 'гб'],
  ['Килобар', 'кб'],
  ['Фарад', 'Ф'],
  ['Килограмм на кубический метр', 'кг/м^3'],
  ['Беккерель', 'Бк'],
  ['Вебер', 'Вб'],
  ['Узел (миля/ч)', 'уз'],
  ['Метр в секунду', 'м/с'],
  ['Оборот в секунду', 'об/с'],
  ['Оборот в минуту', 'об/мин'],
  ['Километр в час', 'км/ч'],
  ['Метр на секунду в квадрате', 'м/с^2'],
  ['Кулон на килограмм', 'Кл/кг'],
  ['Секунда', 'с'],
  ['Минута', 'мин'],
  ['Час', 'ч'],
  ['Сутки', 'сут; дн'],
  ['Неделя', 'нед'],
  ['Декада', 'дек'],
  ['Месяц', 'мес'],
  ['Квартал', 'квартал'],
  ['Полугодие', 'полгода'],
  ['Год', 'г; лет'],
  ['Десятилетие', 'деслет'],
  ['Килограмм в секунду', 'кг/с'],
  ['Тонна пара в час', 'т пар/ч'],
  ['Кубический метр в секунду', 'м^3/с'],
  ['Кубический метр в час', 'м^3/ч'],
  ['Тысяча кубических метров в сутки', '10^3 м^3/сут'],
  ['Бобина', 'боб'],
  ['Лист', 'л.'],
  ['Сто листов', '100 л.'],
  ['Тысяча стандартных условных кирпичей', 'тыс станд. усл. кирп'],
  ['Дюжина (12 шт.)', 'дюжина'],
  ['Изделие', 'изд'],
  ['Сто ящиков', '100 ящ.'],
  ['Набор', 'набор'],
  ['Пара (2 шт.)', 'пар'],
  ['Два десятка', '20'],
  ['Десять пар', '10 пар'],
  ['Дюжина пар', 'дюжина пар'],
  ['Посылка', 'посыл'],
  ['Часть', 'часть'],
  ['Рулон', 'рул'],
  ['Дюжина рулонов', 'дюжина рул'],
  ['Дюжина штук', 'дюжина шт'],
  ['Элемент', 'элем'],
  ['Упаковка', 'упак'],
  ['Дюжина упаковок', 'дюжина упак'],
  ['Сто упаковок', '100 упак'],
  ['Штука', 'шт'],
  ['Десять штук', '10 шт'],
  ['Сто штук', '100 шт'],
  ['Тысяча штук', '1000 шт'],
  ['Миллион штук', '10^6 шт'],
  ['Миллиард штук', '10^9 шт'],
  ['Биллион штук (Европа); триллион штук', '10^12 шт'],
  ['Квинтильон штук (Европа)', '10^18 шт'],
  ['Крепость спирта по массе', 'креп. спирта по массе'],
  ['Крепость спирта по объему', 'креп. спирта по объему'],
  ['Литр чистого (100%) спирта', 'л 100% спирта'],
  ['Гектолитр чистого (100%) спирта', 'Гл 100% спирта'],
  ['Килограмм пероксида водорода', 'кг H^^2О^^2'],
  ['Килограмм 90%-го сухого вещества', 'кг 90% с/в'],
  ['Тонна 90%-го сухого вещества', 'т 90% с/в'],
  ['Килограмм оксида калия', 'кг К^^2О'],
  ['Килограмм гидроксида калия', 'кг КОН'],
  ['Килограмм азота', 'кг N'],
  ['Килограмм гидроксида натрия', 'кг NaOH'],
  ['Килограмм пятиокиси фосфора', 'кг Р^^2О^^5'],
  ['Килограмм урана', 'кг U'],
  ['Погонный метр', 'пог. м'],
  ['Тысяча погонных метров', '10^3 пог. м'],
  ['Условный метр', 'усл. м'],
  ['Тысяча условных метров', '10^3 усл. м'],
  ['Километр условных труб', 'км усл. труб'],
  ['Тысяча квадратных дециметров', '10^3 дм^2'],
  ['Миллион квадратных дециметров', '10^6 дм^2'],
  ['Миллион квадратных метров', '10^6 м^2'],
  ['Тысяча гектаров', '10^3 га'],
  ['Условный квадратный метр', 'усл. м^2'],
  ['Тысяча условных квадратных метров', '10^3 усл. м^2'],
  ['Миллион условных квадратных метров', '10^6 усл. м^2'],
  ['Квадратный метр общей площади', 'м^2 общ. пл'],
  ['Тысяча квадратных метров общей площади', '10^3 м^2 общ. пл'],
  ['Миллион квадратных метров общей площади', '10^6 м^2 общ. пл'],
  ['Квадратный метр жилой площади', 'м^2 жил. пл'],
  ['Тысяча квадратных метров жилой площади', '10^3 м^2 жил. пл'],
  ['Миллион квадратных метров жилой площади', '10^6 м^2 жил. пл'],
  ['Квадратный метр учебно-лабораторных зданий', 'м^2 уч. лаб. здан'],
  ['Тысяча квадратных метров учебно-лабораторных зданий', '10^3 м^2 уч. лаб. здан'],
  ['Миллион квадратных метров в двухмиллиметровом исчислении', '10^6 м^2 2 мм исч'],
  ['Тысяча кубических метров', '10^3 м^3'],
  ['Миллиард кубических метров', '10^9 м^3'],
  ['Декалитр', 'дкл'],
  ['Тысяча декалитров', '10^3 дкл'],
  ['Миллион декалитров', '10^6 дкл'],
  ['Плотный кубический метр', 'плотн. м^3'],
  ['Условный кубический метр', 'усл. м^3'],
  ['Тысяча условных кубических метров', '10^3 усл. м^3'],
  ['Миллион кубических метров переработки газа', '10^6 м^3 перераб. газа'],
  ['Тысяча плотных кубических метров', '10^3 плотн. м^3'],
  ['Тысяча полулитров', '10^3 пол. л'],
  ['Миллион полулитров', '10^6 пол. л'],
  ['Тысяча литров; 1000 литров', '10^3 л; 1000 л'],
  ['Тысяча каратов метрических', '10^3 кар'],
  ['Миллион каратов метрических', '10^6 кар'],
  ['Тысяча тонн', '10^3 т'],
  ['Миллион тонн', '10^6 т'],
  ['Тонна условного топлива', 'т усл. топл'],
  ['Тысяча тонн условного топлива', '10^3 т усл. топл'],
  ['Миллион тонн условного топлива', '10^6 т усл. топл'],
  ['Тысяча тонн единовременного хранения', '10^3 т единовр. хран'],
  ['Тысяча тонн переработки', '10^3 т перераб'],
  ['Условная тонна', 'усл. т'],
  ['Тысяча центнеров', '10^3 ц'],
  ['Вольт-ампер', 'В.А'],
  ['Метр в час', 'м/ч'],
  ['Килокалория', 'ккал'],
  ['Гигакалория', 'Гкал'],
  ['Тысяча гигакалорий', '10^3 Гкал'],
  ['Миллион гигакалорий', '10^6 Гкал'],
  ['Калория в час', 'кал/ч'],
  ['Килокалория в час', 'ккал/ч'],
  ['Гигакалория в час', 'Гкал/ч'],
  ['Тысяча гигакалорий в час', '10^3 Гкал/ч'],
  ['Миллион ампер-часов', '10^6 А.ч'],
  ['Миллион киловольт-ампер', '10^6 кВ.А'],
  ['Киловольт-ампер реактивный', 'кВ.А Р'],
  ['Миллиард киловатт-часов', '10^9 кВт.ч'],
  ['Тысяча киловольт-ампер реактивных', '10^3 кВ.А Р'],
  ['Лошадиная сила', 'л. с'],
  ['Тысяча лошадиных сил', '10^3 л. с'],
  ['Миллион лошадиных сил', '10^6 л. с'],
  ['Бит', 'бит'],
  ['Байт', 'байт'],
  ['Килобайт', 'кбайт'],
  ['Мегабайт', 'Мбайт'],
  ['Бод', 'бод'],
  ['Генри', 'Гн'],
  ['Тесла', 'Тл'],
  ['Килограмм на квадратный сантиметр', 'кг/см^2'],
  ['Миллиметр водяного столба', 'мм вод. ст'],
  ['Миллиметр ртутного столба', 'мм рт. ст'],
  ['Сантиметр водяного столба', 'см вод. ст'],
  ['Микросекунда', 'мкс'],
  ['Миллисекунда', 'млс'],
  ['Рубль', 'руб'],
  ['Тысяча рублей', '10^3 руб'],
  ['Миллион рублей', '10^6 руб'],
  ['Миллиард рублей', '10^9 руб'],
  ['Триллион рублей', '10^12 руб'],
  ['Квадрильон рублей', '10^15 руб'],
  ['Пассажиро-километр', 'пасс.км'],
  ['Пассажирское место (пассажирских мест)', 'пасс. мест'],
  ['Тысяча пассажиро-километров', '10^3 пасс.км'],
  ['Миллион пассажиро-километров', '10^6 пасс. км'],
  ['Пассажиропоток', 'пасс.поток'],
  ['Тонно-километр', 'т.км'],
  ['Тысяча тонно-километров', '10^3 т.км'],
  ['Миллион тонно-километров', '10^6 т. км'],
  ['Тысяча наборов', '10^3 набор'],
  ['Грамм на киловатт-час', 'г/кВт.ч'],
  ['Килограмм на гигакалорию', 'кг/Гкал'],
  ['Тонно-номер', 'т.ном'],
  ['Автотонна', 'авто т'],
  ['Тонна тяги', 'т.тяги'],
  ['Дедвейт-тонна', 'дедвейт.т'],
  ['Тонно-танид', 'т.танид'],
  ['Человек на квадратный метр', 'чел/м^2'],
  ['Человек на квадратный километр', 'чел/км^2'],
  ['Тонна в час', 'т/ч'],
  ['Тонна в сутки', 'т/сут'],
  ['Тонна в смену', 'т/смен'],
  ['Тысяча тонн в сезон', '10^3 т/сез'],
  ['Тысяча тонн в год', '10^3 т/год'],
  ['Человеко-час', 'чел.ч'],
  ['Человеко-день', 'чел.дн'],
  ['Тысяча человеко-дней', '10^3 чел.дн'],
  ['Тысяча человеко-часов', '10^3 чел.ч'],
  ['Тысяча условных банок в смену', '10^3 усл. банк/ смен'],
  ['Миллион единиц в год', '10^6 ед/год'],
  ['Посещение в смену', 'посещ/смен'],
  ['Тысяча посещений в смену', '10^3 посещ/смен'],
  ['Пара в смену', 'пар/смен'],
  ['Тысяча пар в смену', '10^3 пар/смен'],
  ['Миллион тонн в год', '10^6 т/год'],
  ['Тонна переработки в сутки', 'т перераб/сут'],
  ['Тысяча тонн переработки в сутки', '10^3 т перераб/ сут'],
  ['Центнер переработки в сутки', 'ц перераб/сут'],
  ['Тысяча центнеров переработки в сутки', '10^3 ц перераб/ сут'],
  ['Тысяча голов в год', '10^3 гол/год'],
  ['Миллион голов в год', '10^6 гол/год'],
  ['Тысяча птицемест', '10^3 птицемест'],
  ['Тысяча кур-несушек', '10^3 кур. несуш'],
  ['Бит в секунду', 'бит/с'],
  ['Килобит в секунду', 'кбит/с'],
  ['Тысяча тонн пара в час', '10^3 т пар/ч'],
  ['Тысяча прядильных веретен', '10^3 пряд.верет'],
  ['Тысяча прядильных мест', '10^3 пряд.мест'],
  ['Доза', 'доз'],
  ['Тысяча доз', '10^3 доз'],
  ['Единица', 'ед'],
  ['Тысяча единиц', '10^3 ед'],
  ['Миллион единиц', '10^6 ед'],
  ['Канал', 'канал'],
  ['Тысяча комплектов', '10^3 компл'],
  ['Место', 'мест'],
  ['Тысяча мест', '10^3 мест'],
  ['Тысяча номеров', '10^3 ном'],
  ['Тысяча гектаров порций', '10^3 га порц'],
  ['Тысяча пачек', '10^3 пач'],
  ['Процент', '%'],
  ['Промилле (0,1 процента)', '‰'],
  ['Тысяча рулонов', '10^3 рул'],
  ['Тысяча станов', '10^3 стан'],
  ['Станция', 'станц'],
  ['Тысяча тюбиков', '10^3 тюбик'],
  ['Тысяча условных тубов', '10^3 усл.туб'],
  ['Миллион упаковок', '10^6 упак'],
  ['Тысяча упаковок', '10^3 упак'],
  ['Человек', 'чел'],
  ['Тысяча человек', '10^3 чел'],
  ['Миллион человек', '10^6 чел'],
  ['Миллион экземпляров', '10^6 экз'],
  ['Ячейка', 'яч'],
  ['Ящик', 'ящ'],
  ['Голова', 'гол'],
  ['Тысяча пар', '10^3 пар'],
  ['Миллион пар', '10^6 пар'],
  ['Комплект', 'компл'],
  ['Секция', 'секц'],
  ['Бутылка', 'бут'],
  ['Тысяча бутылок', '10^3 бут'],
  ['Ампула', 'ампул'],
  ['Тысяча ампул', '10^3 ампул'],
  ['Флакон', 'флак'],
  ['Тысяча флаконов', '10^3 флак'],
  ['Тысяча тубов', '10^3 туб'],
  ['Тысяча коробок', '10^3 кор'],
  ['Условная единица', 'усл. ед'],
  ['Тысяча условных единиц', '10^3 усл. ед'],
  ['Миллион условных единиц', '10^6 усл. ед'],
  ['Условная штука', 'усл. шт'],
  ['Тысяча условных штук', '10^3 усл. шт'],
  ['Условная банка', 'усл. банк'],
  ['Тысяча условных банок', '10^3 усл. банк'],
  ['Миллион условных банок', '10^6 усл. банк'],
  ['Условный кусок', 'усл. кус'],
  ['Тысяча условных кусков', '10^3 усл. кус'],
  ['Миллион условных кусков', '10^6 усл. кус'],
  ['Условный ящик', 'усл. ящ'],
  ['Тысяча условных ящиков', '10^3 усл. ящ'],
  ['Условная катушка', 'усл. кат'],
  ['Тысяча условных катушек', '10^3 усл. кат'],
  ['Условная плитка', 'усл. плит'],
  ['Тысяча условных плиток', '10^3 усл. плит'],
  ['Условный кирпич', 'усл. кирп'],
  ['Тысяча условных кирпичей', '10^3 усл. кирп'],
  ['Миллион условных кирпичей', '10^6 усл. кирп'],
  ['Семья', 'семей'],
  ['Тысяча семей', '10^3 семей'],
  ['Миллион семей', '10^6 семей'],
  ['Домохозяйство', 'домхоз'],
  ['Тысяча домохозяйств', '10^3 домхоз'],
  ['Миллион домохозяйств', '10^6 домхоз'],
  ['Ученическое место', 'учен. мест'],
  ['Тысяча ученических мест', '10^3 учен. мест'],
  ['Рабочее место', 'раб. мест'],
  ['Тысяча рабочих мест', '10^3 раб. мест'],
  ['Посадочное место', 'посад. мест'],
  ['Тысяча посадочных мест', '10^3 посад. мест'],
  ['Номер', 'ном'],
  ['Квартира', 'кварт'],
  ['Тысяча квартир', '10^3 кварт'],
  ['Койка', 'коек'],
  ['Тысяча коек', '10^3 коек'],
  ['Том книжного фонда', 'том книжн. фонд'],
  ['Тысяча томов книжного фонда', '10^3 том. книжн. фонд'],
  ['Условный ремонт', 'усл. рем'],
  ['Условный ремонт в год', 'усл. рем/год'],
  ['Смена', 'смен'],
  ['Лист авторский', 'л. авт'],
  ['Лист печатный', 'л. печ'],
  ['Лист учетно-издательский', 'л. уч.-изд'],
  ['Знак', 'знак'],
  ['Слово', 'слово'],
  ['Символ', 'символ'],
  ['Условная труба', 'усл. труб'],
  ['Тысяча пластин', '10^3 пласт'],
  ['Миллион доз', '10^6 доз'],
  ['Миллион листов-оттисков', '10^6 лист.оттиск'],
  ['Вагоно(машино)-день', 'ваг (маш).дн'],
  ['Тысяча вагоно-(машино)-часов', '10^3 ваг (маш).ч'],
  ['Тысяча вагоно-(машино)-километров', '10^3 ваг (маш).км'],
  ['Тысяча место-километров', '10 ^3мест.км'],
  ['Вагоно-сутки', 'ваг.сут'],
  ['Тысяча поездо-часов', '10^3 поезд.ч'],
  ['Тысяча поездо-километров', '10^3 поезд.км'],
  ['Тысяча тонно-миль', '10^3 т.миль'],
  ['Тысяча пассажиро-миль', '10^3 пасс.миль'],
  ['Автомобиле-день', 'автомоб.дн'],
  ['Тысяча автомобиле-тонно-дней', '10^3 автомоб.т.дн'],
  ['Тысяча автомобиле-часов', '10^3 автомоб.ч'],
  ['Тысяча автомобиле-место-дней', '10^3 автомоб.мест. дн'],
  ['Приведенный час', 'привед.ч'],
  ['Самолето-километр', 'самолет.км'],
  ['Тысяча километров', '10^3 км'],
  ['Тысяча тоннаже-рейсов', '10^3 тоннаж. рейс'],
  ['Миллион тонно-миль', '10^6 т. миль'],
  ['Миллион пассажиро-миль', '10^6 пасс. миль'],
  ['Миллион тоннаже-миль', '10^6 тоннаж. миль'],
  ['Миллион пассажиро-место-миль', '10^6 пасс. мест. миль'],
  ['Кормо-день', 'корм. дн'],
  ['Центнер кормовых единиц', 'ц корм ед'],
  ['Тысяча автомобиле-километров', '10^3 автомоб. км'],
  ['Тысяча тоннаже-сут', '10^3 тоннаж. сут'],
  ['Суго-сутки', 'суго. сут.'],
  ['Штук в 20-футовом эквиваленте (ДФЭ)', 'штук в 20-футовом эквиваленте'],
  ['Канало-километр', 'канал. км'],
  ['Канало-концы', 'канал. конц'],
  ['Тысяча экземпляров', '10^3 экз'],
  ['Тысяча долларов', '10^3 доллар'],
  ['Тысяча тонн кормовых единиц', '10^3 корм ед'],
  ['Миллион тонн кормовых единиц', '10^6 корм ед'],
  ['Судо-сутки', 'суд.сут'],
  ['Мегабит в секунду', 'Мбит/с'],
  ['Гигабит в секунду', 'Гбит/с'],
  ['Байт в секунду', 'Байт/с'],
  ['Гигабайт в секунду', 'Гбайт/с'],
  ['Килобайт в секунду', 'кбайт/с'],
  ['Мегабайт в секунду', 'Мбайт/с'],
  ['Эрланг', 'Эрл'],
  ['Грей', 'Гр'],
  ['Децибел', 'Дб'],
  ['Абонент', 'Абонент'],
  ['Миллион гектаров', '10^6 га'],
  ['Миллиард гектаров', '10^9 га'],
  ['Миллион голов', '10^6 гол'],
  ['Балл', 'балл'],
  ['Миллион долларов', '10^6 доллар'],
  ['Центнеров с гектара', 'ц/га'],
  ['Тысяча голов', '10^3 гол'],
  ['Тысяча краско-оттисков ', '10^3 краск. оттиск'],
  ['Миллион краско-оттисков', '10^6 краск. оттиск'],
  ['Миллион условных плиток', '10^6 усл. плит'],
  ['Человек в час', 'чел/ч'],
  ['Пассажиров в час', 'пасс/ч'],
  ['Пассажиро-миля', 'пасс. миля'],
  ['Гигабайт', 'Гбайт'],
  ['Терабайт', 'Тбайт'],
  ['Петабайт', 'Пбайт'],
  ['Эксабайт', 'Эбайт'],
  ['Зеттабайт', 'Збайт'],
  ['Йоттабайт', 'Йбайт'],
  ['Рубль тонна', 'руб. тонна'],
  ['Дето-день', 'дет. дн'],
  ['Человек в год', 'чел/год'],
  ['Посещение', 'посещ'],
  ['Тысяча гнезд', '10^3 гнезд'],
  ['Единиц в год', 'ед/год'],
  ['Вызов', 'вызов'],
  ['Штамм', 'штамм'],
  ['Особь', 'ос'],
  ['Коробка', 'кор'],
  ['Койко-день', 'койк. дн'],
  ['Пациенто-день', 'пациент. дн'],
  ['Запись', 'запись'],
  ['Документ', 'докум'],
  ['Лист-оттиск', 'лист. оттиск'],
  ['Вагоно (машино)-час', 'ваг (маш) ч'],
  ['Летный час', 'летн. ч'],
  ['Миллиард долларов', '10^9 доллар'],
  ['Доллар за тонну', 'доллар за тонну'],
  ['Посевная единица', 'пос.ед'],
  ['Тысяча метров кубических в час', '103 м^3/ч'],
  ['Микрограмм', 'мкг'],
  ['Килобеккерель', 'кБк'],
  ['Мегабеккерель', 'МБк'],
  ['Моль', 'моль'],
  ['Международная единица биологической активности', 'МЕ'],
  ['Тысяча международных единиц биологической активности', 'тыс. МЕ'],
  ['Миллион международных единиц биологической активности', 'млн. МЕ'],
  ['Международная единица биологической активности на грамм', 'МЕ/г'],
  ['Тысяча международных единиц биологической активности на грамм', 'тыс. МЕ/г'],
  ['Миллион международных единиц биологической активности на грамм', 'млн. МЕ/г'],
  ['Международная единица биологической активности на миллилитр', 'МЕ/мл'],
  ['Тысяча международных единиц биологической активности на миллилитр', 'тыс. МЕ/мл'],
  ['Миллион международных единиц биологической активности на миллилитр', 'млн. МЕ/мл'],
  ['Единица действия биологической активности', 'ЕД'],
  ['Единица биологической активности на грамм', 'ЕД/г'],
  ['Тысяча единиц действия биологической активности на грамм', 'тыс. ЕД/г'],
  ['Единица действия биологической активности на микролитр', 'ЕД/мкл'],
  ['Единица действия биологической активности на миллилитр', 'ЕД/мл'],
  ['Тысяча единиц действия биологической активности на миллилитр', 'тыс. ЕД/мл'],
  ['Миллион единиц действия биологической активности на миллилитр', 'млн. ЕД/мл'],
  ['Единица действия биологической активности в сутки', 'ЕД/сут'],
  ['Антитоксическая единица', 'АЕ'],
  ['Тысяча антитоксических единиц', 'тыс. АЕ'],
  ['Антитрипсиновая единица', 'АТрЕ'],
  ['Тысяча антитрипсиновых единиц', 'тыс. АТрЕ'],
  ['Индекс Реактивности', 'ИР'],
  ['Индекс Реактивности на миллилитр', 'ИР/мл'],
  ['Килобеккерель на миллилитр', 'кБк/мл'],
  ['Мегабеккерель на миллилитр', 'МБк/мл'],
  ['Мегабеккерель на метр квадратный', 'МБк/м<sup>2</sup>'],
  ['Калликреиновая ингибирующая единица на миллилитр', 'КИЕ/мл'],
  ['Тысяча калликреиновых ингибирующих единиц на миллилитр', 'тыс. КИЕ/МЛ'],
  ['Миллион колониеобразующих единиц', 'млн. КОЕ'],
  ['Миллион колониеобразующих единиц на пакет', 'млн. КОЕ/пакет'],
  ['Миллиард колониеобразующих единиц', 'млрд. КОЕ'],
  ['Протеолитическая единица', 'ПЕ'],
  ['Микрограмм на миллилитр', 'Мкг/мл'],
  ['Микрограмм в сутки', 'Мкг/сут'],
  ['Микрограмм в час', 'Мкг/ч'],
  ['Микрограмм на дозу', 'Мкг/доза'],
  ['Миллимоль на миллилитр', 'моль/мл'],
  ['Миллимоль на литр', 'ммоль/л'],
  ['Пачка', 'пач'],
  ['Километр в сутки', 'км/сут'],
  ['Микрогрей', 'мкГр'],
  ['Миллигрей', 'мГр'],
  ['Килогрей', 'кГр'],
  ['Гигагерц', 'ГГц'],
  ['Терагерц', 'ТГц'],
  ['Наносекунда', 'нс'],
  ['Зиверт', 'Зв'],
  ['Микрозиверт', 'мкЗв'],
  ['Миллизиверт', 'мЗв'],
  ['Фемтосекунда', 'фс'],
  ['Пикосекунда', 'пс'],
  ['Грей в секунду', 'Гр/с'],
  ['Грей в минуту', 'Гр/мин'],
  ['Грей в час', 'Гр/ч'],
  ['Микрогрей в секунду', 'мкГр/с'],
  ['Микрогрей в час', 'мкГр/ч'],
  ['Миллигрей в час', 'мГр/ч'],
  ['Зиверт в час', 'Зв/ч'],
  ['Микрозиверт в секунду', 'мкЗв/с'],
  ['Микрозиверт в час', 'мкЗв/ч'],
  ['Миллизиверт в час', 'мЗв/ч'],
  ['Пар грузовых поездов в сутки', 'пар груз поезд/сут'],
  ['Базисный пункт', 'б.п.'],
  ['Грамм условного топлива на киловатт-час', 'г у.т./кВт•ч'],
  ['Килограмм условного топлива на гигакалорию', 'кг у.т./Гкал'],
  ['Миллиард евро', '10^9 евро'],
]

const ciList = ci.map((item) => ({
  name: item[0],
  value: item[1],
}))

export default ciList
